export default __webpack_public_path__ + "static/splunk-d6893c4daca04749fcd52b9c4370d254.jpg";